import React from 'react'
import { useState } from 'react'
import { Button, ButtonGroup, Card, Table } from 'react-bootstrap'
import AdminPicker from '../../../components/AdminPicker/AdminPicker'
import callAPI from '../../../helpers/callAPI'
import useCallApi from '../../../hooks/useCallApi'
import Advertiser from '../../../templates/Advertiser/Advertiser'
import Loading from '../../../templates/UI/Loading/Loading'
import Affiliate from '../../../templates/Affiliate/Affiliate'
import Campaign from '../../../templates/Campaign/Campaign'
import Dollars from '../../../templates/Dollars/Dollars'
import moment from 'moment'
import useQueryParams from '../../../hooks/useQueryParams'
import ReportTable from '../../../templates/ReportTable/ReportTable'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

const APILeadsReview = ({ showSystemMessage }) => {
    const { adminId, setAdminId } = useQueryParams()
    const { data, dataLoaded, refetch } = useCallApi(`advertisers/apiLeadsReview?adminId=${adminId}`, 'GET', {}, [adminId], showSystemMessage)
    const [markAllReviewedButtonConfirmed, setMarkAllReviewedButtonConfirmed] = useState(false)

    const markAsReviewed = async (id) => {
        const result = await callAPI(`advertisers/apiLeadsReview/${id}`, 'PUT')
        if (result.success) {
            showSystemMessage('success', 'API Lead Reviewed')
            refetch()
        } else {
            showSystemMessage('error', 'Error Updating API Lead')
        }
    }

    const markAllAsReviewed = async () => {
        let ids = []
        
        data.data.forEach((row) => {
            if (row.reviewed != 'Y') {
                ids.push(row.id)
            }
        })
        
        const result = await callAPI(`advertisers/apiLeadsReviewAll`, 'PUT', { ids })
        if (result.success) {
            showSystemMessage('success', 'API Leads Reviewed')
            refetch()
        } else {
            showSystemMessage('error', 'Error Updating API Leads / No Leads to Review.')
        }
    }

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'Campaign',
                accessor: 'offer_name',
                Cell: (tableData) => {
                    return <Campaign name={tableData.row.original.offer_name} oid={tableData.row.original.offer_id} />
                }
            },
            {
                Header: 'Affiliate',
                accessor: 'name',
                Cell: (tableData) => {
                    return <Affiliate name={tableData.row.original.name} aid={tableData.row.original.affiliate_id} />
                }
            },
            {
                Header: 'Platform',
                accessor: 'platform_name',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: () => <div style={{ textAlign: 'right' }}>Net Rate</div>,
                accessor: 'net_rate',
                className: 'text-right',
                Cell: ({ cell: { value } }) => {
                    return <Dollars value={value}/>
                },
            },
            {
                Header: () => <div style={{ textAlign: 'right' }}>Sale</div>,
                accessor: 'sale_amount',
                className: 'text-right',
                Cell: ({ cell: { value } }) => {
                    return <Dollars value={value}/>
                },
            },
            {
                Header: 'Lead Data',
                accessor: 'lead_data',
                Cell: ({ cell: { value } }) => {
                    return <>{value ? <Link to={`/searchId?leadData=${value}`}>{value}</Link> : value}</>
                },
            },
            {
                Header: 'Date',
                accessor: 'transaction_date',
                Cell: ({ cell: { value } }) => {
                    return <>{moment(value).utc().format('YYYY-MM-DD HH:mm:ss')}</>
                },
            },
            {
                Header: 'Note',
                accessor: 'notes',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: '',
                accessor: 'id',
                Cell: (tableData) => {
                    return <>{tableData.row.original.reviewed != 'Y' ? (
                        <Button
                            variant="primary"
                            size="sm"
                            onClick={() => {
                                markAsReviewed(tableData.row.original.id)
                            }}
                        >
                            reviewed
                        </Button>
                    ) : (
                        ''
                    )}</>
                },
                
            }
        ]

        return (
            <React.Fragment>
                <ReportTable
                    data={data.data}
                    columns={columns}
                    getRowProps={(row) => {
                        if (row.original.reviewed == 'Y') {
                            return {
                                className: `bgSuccess25`,
                            }
                        }
                    }}
                />
            </React.Fragment>
        )
    }

    return (
        <Card>
            <Card.Header className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                    <h1 className="mb-h1-dark mr-2">API Leads to Review</h1>
                    <div>
                        <AdminPicker adminId={adminId} setAdminId={setAdminId} role={['MERMGR', 'BIZDEV', 'BIZDEV_DIRECTOR', 'ADMIN', 'ADOPS_TEAMLEAD', 'ADOPS_MANAGER']} />
                    </div>
                </div>
                {!markAllReviewedButtonConfirmed ? (
                    <button className="btn btn-primary btn-sm ml-2" onClick={() => setMarkAllReviewedButtonConfirmed(true)}>
                        Mark All As Reviewed
                    </button>) : (
                    <button className="btn btn-primary btn-sm ml-2" onClick={markAllAsReviewed}>
                        Confirm
                    </button>
                )}                
            </Card.Header>
            {dataLoaded ? data.data.length === 0 ? <div className="p-3">No stats for the current parameters.</div> : getReportOutput() : <Loading />}
        </Card>
    )
}

export default APILeadsReview
